import { TableBody, TableHead, TableRow } from '@mui/material';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { Case } from '../../../../shared/api/hscan/case';
import { useReport } from '../../../../shared/hooks/caseHook';
import {
  HscanTable,
  HscanTableCell,
} from '../../common/components/SortableTable/Table';
import { useModalityLabel } from '../../hooks/modalityHook';

import {
  DownloadSingleCaseButton,
  InlineTableButton,
} from './DownloadSingleCaseButton';
import { ViewReportModal } from './ViewReportModal';

interface ImageInfoTableProps {
  caseInfo: Case;
}
export const ImageInfoTable = (props: ImageInfoTableProps) => {
  const { caseInfo } = props;
  const { t } = useTranslation('translation', {
    keyPrefix: 'features.imageList.imageDetails.imageInfoTable',
  });
  const { t: reportTrans } = useTranslation('translation', {
    keyPrefix: 'features.imageList.imageDetails',
  });
  const modalityLabel = useModalityLabel();

  const [open, setOpen] = useState(false);

  const { data, error } = useReport(caseInfo.caseId);
  const reportPlainText = data?.plainText ?? '';
  const isReportAvailable = !error && reportPlainText !== '';

  return (
    <>
      <HscanTable
        head={
          <TableHead>
            <TableRow>
              <HscanTableCell>{`${t('header.studyDate')}`}</HscanTableCell>
              <HscanTableCell>{`${t('header.modality')}`}</HscanTableCell>
              <HscanTableCell>{`${t('header.bodyPart')}`}</HscanTableCell>
              {isReportAvailable && (
                <HscanTableCell align="center">{`${t(
                  'header.report',
                )}`}</HscanTableCell>
              )}
              <HscanTableCell align="center">{`${t(
                'header.download',
              )}`}</HscanTableCell>
            </TableRow>
          </TableHead>
        }
        body={
          <TableBody>
            <TableRow>
              <HscanTableCell>{caseInfo.studyDate}</HscanTableCell>
              <HscanTableCell>
                {modalityLabel(caseInfo.modality)}
              </HscanTableCell>
              <HscanTableCell>{caseInfo.bodyPart?.join(', ')}</HscanTableCell>
              {isReportAvailable && (
                <HscanTableCell align="center">
                  <InlineTableButton onClick={() => setOpen(true)}>
                    {reportTrans('reportButton')}
                  </InlineTableButton>
                </HscanTableCell>
              )}
              <HscanTableCell align="center">
                <DownloadSingleCaseButton caseId={caseInfo.caseId} />
              </HscanTableCell>
            </TableRow>
          </TableBody>
        }
      />
      <ViewReportModal
        open={open}
        onClose={() => setOpen(false)}
        reportPlainText={reportPlainText}
      />
    </>
  );
};
